// Band-color palette — driving the spot dot fill on the map and the band
// chip in the table. Aligned with HolyCluster's encoding so operators see
// familiar colours.
export const BAND_COLOR = {
  '160': '#9b59b6',
  '80':  '#8e44ad',
  '60':  '#5d4037',
  '40':  '#e74c3c',
  '30':  '#e67e22',
  '20':  '#f1c40f',
  '17':  '#27ae60',
  '15':  '#1abc9c',
  '12':  '#3498db',
  '10':  '#2980b9',
  '8':   '#34495e',
  '6':   '#e91e63',
  '4':   '#9c27b0',
  // LF, VHF, UHF, SHF cover both the amateur allocations within their
  // ranges (2200m+630m, 2m, 70cm/23cm/13cm, 6cm/3cm) and any non-amateur
  // spot landing there.
  'LF':  '#283593',
  'VHF': '#673ab7',
  'UHF': '#3949ab',
  'SHF': '#558b2f',
  'unknown': '#7f8c8d',
};

export function bandColor(b) {
  return BAND_COLOR[b] || BAND_COLOR.unknown;
}

// Canonical, wavelength-descending list of every band the toolbar /
// settings know about. Used by SettingsPanel for the visibility picker
// and by Toolbar for chip rendering.
export const ALL_BANDS = [
  'LF',
  '160', '80', '60', '40', '30', '20', '17', '15', '12', '10',
  '8', '6', '4',
  'VHF', 'UHF', 'SHF',
];

// DEFAULT_VISIBLE_BANDS is the chip set surfaced in the toolbar by
// default — HF plus 6m/4m and the VHF (2m) bucket. LF/UHF/SHF and the
// rare 8m allocation are off by default; users opt them in from Settings.
export const DEFAULT_VISIBLE_BANDS = [
  '160', '80', '60', '40', '30', '20', '17', '15', '12', '10',
  '6', '4',
  'VHF',
];
